var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconInternational128(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 129,
    viewBox: "0 0 128 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_18930)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 112.503C90.5097 112.503 112 91.0126 112 64.5029C112 37.9933 90.5097 16.5029 64 16.5029C37.4903 16.5029 16 37.9933 16 64.5029C16 91.0126 37.4903 112.503 64 112.503Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1916_18930",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 96,
    height: 97
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 112.503C90.5097 112.503 112 91.0126 112 64.5029C112 37.9933 90.5097 16.5029 64 16.5029C37.4903 16.5029 16 37.9933 16 64.5029C16 91.0126 37.4903 112.503 64 112.503Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1916_18930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 112.503C90.5097 112.503 112 91.0126 112 64.5029C112 37.9933 90.5097 16.5029 64 16.5029C37.4903 16.5029 16 37.9933 16 64.5029C16 91.0126 37.4903 112.503 64 112.503Z",
    stroke: "#918F90",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3924 14.0398C67.7334 17.8654 64.3453 22.6786 64.2281 28.4795C64.0524 37.1809 75.4299 32.505 75.4299 38.7884C75.4299 45.0718 68.0128 46.2313 61.3394 39.8438C54.6661 33.4564 47.2723 32.7346 40.6442 38.4446C34.0161 44.1546 32.9271 59.1771 44.3432 61.5027C55.7592 63.8283 57.4234 64.7345 57.4234 76.2904C57.4234 87.8463 58.9264 90.3475 67.8755 90.3475C76.8245 90.3475 72.0409 81.0006 75.4299 74.9463C78.8189 68.8919 84.6759 65.7321 84.6759 60.8098C84.6759 55.8875 73.3076 56.7385 75.4299 49.8672C77.5522 42.9958 87.6237 46.7204 92.5066 43.8499C97.3896 40.9795 100.729 29.699 99.3964 28.4795C98.7812 27.9168 96.5795 24.7278 89.8274 20.6095C87.3964 19.1268 85.5282 17.2258 82.5682 16.2791C80.2989 15.3649 77.5737 14.6184 74.3924 14.0398Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 112.503C90.5097 112.503 112 91.0126 112 64.5029C112 37.9933 90.5097 16.5029 64 16.5029C37.4903 16.5029 16 37.9933 16 64.5029C16 91.0126 37.4903 112.503 64 112.503Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.8
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_18930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconInternational128);
export default __webpack_public_path__ + "static/media/pictogramBeaconInternational128.64cf2cff5c3271dc619083fbdec10519.svg";
export { ForwardRef as ReactComponent };